const htmlToRouterLinksMixin = {

	mounted() {
		this.$el.addEventListener('click', this.routeLinks.bind(this));
	},

	methods: {
		routeLinks(event) {
			// ensure we use the link, in case the click has been received by a subelement
			let { target } = event

			while (target && target.tagName !== 'A') target = target.parentNode

			const route = this.linkToRoute(target);

			// handle only links that do not reference external resources
			if (route) {
				// some sanity checks taken from vue-router:
				// https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
				const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = event
				// don't handle with control keys
				if (metaKey || altKey || ctrlKey || shiftKey) return
				// don't handle when preventDefault called
				if (defaultPrevented) return
				// don't handle right clicks
				if (button !== undefined && button !== 0) return
				// don't handle if `target="_blank"`
				if (target && target.getAttribute) {
					const linkTarget = target.getAttribute('target')
					if (/\b_blank\b/i.test(linkTarget)) return
				}
				
				if (window.location.pathname !== route && event.preventDefault) {
					event.preventDefault()
					this.$router.push(route)
				}
			}
		},
		isRouteable(target) {
			return target.hostname == window.location.hostname &&
				target.pathname.startsWith(this.$router.options.base);

		},
		linkToRoute(target){
			if( !target || !target.href ){
				return false;
			}
			if( !(target.hostname == window.location.hostname &&
				target.pathname.startsWith(this.$router.options.base)) ){
				return false;
			}
			let route = target.pathname.substring( 
				this.$router.options.base.length
			)
			if( !route.startsWith('/') ){
				route = '/'+route;
			}
			return route;
		}
	}
}

const inViewMixin = {
	created() {
		this.intersectionObserver = new IntersectionObserver( entries => {
			let count = 0;
			let delay = 0;
			let initial_delay = 150;
			entries.sort((a,b)=>{
				return a.boundingClientRect.y - b.boundingClientRect.y;
			}).forEach( (entry, i) => {
				if( entry.isIntersecting ){
					setTimeout( () => entry.target.classList.add('in-view'), delay );
					delay += Math.max(0, initial_delay - (count++ * 10));
				}
				else {
					// entry.target.classList.remove('in-view')
				}
			});
		}, {
			
		});

		// lets add to our router
		if( this.$router ){
			this.$router.afterEach((to,from)=>{
				clearTimeout( this.refreshTimeout );
				this.intersectionObserver.disconnect();
				this.refreshTimeout = setTimeout( () => this.refreshInView(), 10);
			});
		}

	},

	mounted(){
		this.refreshInView();
	},

	destroyed(){
		// remove intersection observer
		this.intersectionObserver.disconnect();
	},

	methods : {
		refreshInView(){
			// look for all the 
			const els = this.$el.querySelectorAll('[data-in-view]');
			if( els ) for( let i =0; i< els.length; i++){
				this.intersectionObserver.observe( els[i] );
			}
		}
	}
}

export { htmlToRouterLinksMixin, inViewMixin};